<template>
  <div class="dl-page">

    <!-- Hero -->
    <div class="dl-hero">
      <div class="d-flex align-center" style="gap:14px;">
        <v-avatar color="rgba(255,255,255,0.15)" size="46">
          <v-icon color="white" size="26">mdi-tag-minus-outline</v-icon>
        </v-avatar>
        <div>
          <div class="dl-hero__title">
            <span v-if="estado == 'solicitado'">Descuentos pendientes de aprobación</span>
            <span v-else-if="estado == 'aprobado'">Descuentos aprobados</span>
            <span v-else>Descuentos rechazados</span>
          </div>
          <div class="dl-hero__sub">Gestión y seguimiento de descuentos académicos</div>
        </div>
      </div>
      <v-chip small color="rgba(255,255,255,0.15)" dark>
        <v-icon left small>mdi-school-outline</v-icon> Académico
      </v-chip>
    </div>

    <div class="dl-body">

      <!-- Filtros -->
      <v-card outlined class="dl-filters-card mb-4">
        <v-card-title class="dl-filters-card__title py-2 px-4">
          <v-icon small color="indigo darken-2" class="mr-1">mdi-filter-outline</v-icon>
          Filtros de búsqueda
        </v-card-title>
        <v-card-text class="pt-3 pb-3 px-4">
          <v-row dense align="center">
            <v-col cols="12" sm="3">
              <v-combobox v-model="tipo_descuento" :items="tipos_des"
                label="Tipo de descuento" hide-details outlined dense
                prepend-inner-icon="mdi-tag-outline" />
            </v-col>
            <v-col cols="12" sm="2">
              <v-combobox v-model="estado"
                :items="['solicitado', 'aprobado', 'rechazado']"
                label="Estado" hide-details outlined dense
                prepend-inner-icon="mdi-check-circle-outline" />
            </v-col>
            <v-col cols="12" sm="3">
              <v-combobox v-model="filtroprograma" :items="programas"
                label="Programa" :loading="isloadingprograma"
                placeholder="Seleccione un programa..."
                hide-details outlined dense
                prepend-inner-icon="mdi-book-outline" />
            </v-col>
            <v-col cols="12" sm="4">
              <v-combobox v-model="filtroestudiante" :items="estudiantes"
                label="Carnet estudiante" :loading="isloadingestudent"
                placeholder="Tecla enter para buscar..."
                hide-details outlined dense
                prepend-inner-icon="mdi-account-search-outline" />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Tabla -->
      <v-card outlined class="dl-table-card">

        <!-- Toolbar -->
        <div class="dl-table-toolbar px-4 py-2 d-flex align-center flex-wrap" style="gap:8px;">
          <v-chip x-small :color="datos.length ? 'indigo lighten-5' : 'grey lighten-3'"
            class="indigo--text text--darken-2 font-weight-medium">
            {{ datos.length }} registro{{ datos.length !== 1 ? 's' : '' }}
          </v-chip>
          <v-chip x-small :color="estadoChipColor(estado)" class="font-weight-medium" label>
            <v-icon left x-small>{{ estadoChipIcon(estado) }}</v-icon>
            {{ estado }}
          </v-chip>
          <v-spacer />
          <v-progress-circular v-if="loading" indeterminate color="indigo" size="20" width="2" />
        </div>

        <v-divider />

        <v-data-table
          :headers="headers"
          :items="datos"
          :loading="loading"
          hide-default-footer
          dense
          loading-text="Cargando descuentos..."
          no-data-text="Sin datos para los filtros seleccionados."
          class="dl-table"
        >
          <!-- Monto -->
          <template v-slot:[`item.monto`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on" class="font-weight-medium">{{ item.monto }} <small class="grey--text">Bs.</small></span>
              </template>
              <span>ID: {{ item.id }}</span>
            </v-tooltip>
          </template>

          <!-- Fecha -->
          <template v-slot:[`item.fecha_registro`]="{ item }">
            {{ parsefecha(item.fecha_registro) }}
          </template>

          <!-- Prorrateo -->
          <template v-slot:[`item.prorrateadoActivo`]="{ item }">
            <v-chip x-small label
              :color="item.prorrateadoActivo ? 'blue lighten-5' : 'grey lighten-3'"
              :class="item.prorrateadoActivo ? 'blue--text text--darken-2' : 'grey--text text--darken-1'">
              {{ item.prorrateadoActivo ? 'Sí' : 'No' }}
            </v-chip>
          </template>

          <!-- Estudiante -->
          <template v-slot:[`item.estudiante`]="{ item }">
            {{ item.estudiante.nombres }} {{ item.estudiante.primer_apellido }} {{ item.estudiante.segundo_apellido }}
          </template>

          <!-- Solicitante -->
          <template v-slot:[`item.user_solicitante`]="{ item }">
            {{ parseuser(item.user_solicitante) }}
          </template>

          <!-- Responsable -->
          <template v-slot:[`item.user_responsable`]="{ item }">
            {{ parseuser(item.user_responsable) }}
          </template>

          <!-- Estado -->
          <template v-slot:[`item.estado`]="{ item }">
            <v-chip x-small label
              :color="estadoChipColor(item.estado)"
              class="font-weight-medium">
              <v-icon left x-small>{{ estadoChipIcon(item.estado) }}</v-icon>
              {{ item.estado }}
            </v-chip>
          </template>

          <!-- Opciones -->
          <template v-slot:[`item.opciones`]="{ item }">
            <div class="d-flex align-center" style="gap:4px;">
              <v-tooltip bottom v-if="item.estado == 'solicitado' && ($store.state.CARGO.id == 14 || $store.state.CARGO.id == 1)">
                <template v-slot:activator="{ on }">
                  <v-btn icon x-small color="green darken-1"
                    :disabled="idrol != 1 && (tipo_descuento.text == 'Liquidación de Cartera' || tipo_descuento.text == 'Compensación por cambio de plan')"
                    v-on="on" @click="aprobardescuento(item)">
                    <v-icon x-small>mdi-clipboard-check-outline</v-icon>
                  </v-btn>
                </template>
                <span>Dar respuesta</span>
              </v-tooltip>

              <v-tooltip bottom v-if="item.estado == 'aprobado' && ($store.state.CARGO.id == 14 || $store.state.CARGO.id == 1)">
                <template v-slot:activator="{ on }">
                  <v-btn icon x-small color="red darken-1"
                    :disabled="idrol != 1 && (tipo_descuento.text == 'Liquidación de Cartera' || tipo_descuento.text == 'Compensación por cambio de plan')"
                    v-on="on" @click="revertirdescuento(item)">
                    <v-icon x-small>mdi-clipboard-remove-outline</v-icon>
                  </v-btn>
                </template>
                <span>Revertir</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon x-small color="indigo darken-1" v-on="on" @click="verdescuento(item)">
                    <v-icon x-small>mdi-eye-outline</v-icon>
                  </v-btn>
                </template>
                <span>Ver detalles</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>

        <v-divider v-if="page_tam > 1" />
        <div v-if="page_tam > 1" class="d-flex justify-center py-2">
          <v-pagination
            v-model="page"
            :length="page_tam"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            total-visible="7"
            color="indigo darken-1"
          />
        </div>

        <p v-if="msg" class="text-center red--text ma-2" style="font-size:0.85rem;">
          <b>{{ msg }}</b>
        </p>
      </v-card>

    </div>

    <ADescuentoAprobacion ref="descuentoestado" v-on:onrespuesta="onrespuesta" />
    <ADescuentoReversion ref="ndescuentorever" v-on:onrespuesta="onrespuesta" />
    <ADescuentoVer ref="ndescuentover" v-on:onrespuesta="onrespuesta" />
    <ABuscarPersona ref="abuscarpersona" v-on:resultadobusquedaest="resultadobusquedaest" />
    <ABuscarProgramas ref="abuscarprogramas" v-on:onloadprogramas="onloadprogramas" />
  </div>
</template>

<script>
  import ADescuentoAprobacion from '@/components/ADescuentoAprobacion';
  import ADescuentoReversion from '@/components/ADescuentoReversion';
  import ADescuentoVer from '@/components/ADescuentoVer';
  import ABuscarPersona from '@/components/ABuscarPersona';
  import ABuscarProgramas from '@/components/ABuscarProgramas';
  import xaxios from '@/xaxios';

  export default {
    data() {
      return {
        insseleccionado: {},
        seleccionado: {},
        programas: [],
        estudiantes: [],
        datos: [],
        estado: 'solicitado',
        timeoutHnd: 0,
        filtroestudiante: '',
        filtroprograma: '',
        buscar: '',
        msg: '',
        isloadingestudent: false,
        isloadingprograma: false,
        loading: false,
        size: 20,
        page: 1,
        page_tam: 0,
        tipo_descuento: { id: 2, text: 'Descuento' },
        tipos_des: [],
        idrol: -1,
        headers: [
          { text: 'Nro',           value: 'nro',               width: '60',  sortable: false },
          { text: 'Monto',         value: 'monto',             width: '100' },
          { text: 'Descripción',   value: 'descripcion' },
          { text: 'Fecha registro',value: 'fecha_registro',    width: '140' },
          { text: 'Prorrateo',     value: 'prorrateadoActivo', width: '90' },
          { text: 'Estudiante',    value: 'estudiante' },
          { text: 'Solicitante',   value: 'user_solicitante' },
          { text: 'Responsable',   value: 'user_responsable',  width: '160' },
          { text: 'Estado',        value: 'estado',            width: '110' },
          { text: 'Opciones',      value: 'opciones',          width: '90',  sortable: false },
        ],
      };
    },
    components: { ADescuentoAprobacion, ADescuentoReversion, ADescuentoVer, ABuscarPersona, ABuscarProgramas },
    watch: {
      estado: function() {
        if (this.page == 1) this.getDatos();
        else this.page = 1;
      },
      'tipo_descuento.id': function() {
        if (this.page == 1) this.getDatos();
        else this.page = 1;
      },
      page: function() {
        this.getDatos();
      },
      '$store.state.CARGO.sede': function() {
        this.getDatos();
      },
      filtroprograma: function() {
        this.getDatos();
      },
      filtroestudiante: function() {
        if (!this.filtroestudiante) {
          this.filtroestudiante = '';
          this.getDatos();
        }
        if (typeof this.filtroestudiante == 'object') {
          this.getDatos();
          return;
        }
        if (this.timeoutHnd) {
          clearTimeout(this.timeoutHnd);
          this.timeoutHnd = 0;
        }
        var vue = this;
        this.timeoutHnd = setTimeout(function() {
          if (vue.filtroestudiante.length > 2) {
            vue.estudiantes = [];
            vue.asyncfindestudiante(false);
          } else {
            vue.msg = '';
            vue.estudiantes = [];
          }
          this.timeoutHnd = 0;
        }, 500);
      },
    },
    methods: {
      estadoChipColor(e) {
        if (e === 'solicitado') return 'amber lighten-4';
        if (e === 'aprobado')   return 'green lighten-5';
        if (e === 'rechazado')  return 'red lighten-5';
        return 'grey lighten-3';
      },
      estadoChipIcon(e) {
        if (e === 'solicitado') return 'mdi-clock-outline';
        if (e === 'aprobado')   return 'mdi-check-circle-outline';
        if (e === 'rechazado')  return 'mdi-close-circle-outline';
        return 'mdi-help-circle-outline';
      },
      editar(obj) {
        this.seleccionado = obj;
      },
      modalExitof() {
        this.getDatos();
      },
      aprobardescuento(ins) {
        this.insseleccionado = ins;
        this.$refs.descuentoestado.setdescuento(ins);
      },
      revertirdescuento(ins) {
        this.insseleccionado = ins;
        this.$refs.ndescuentorever.setdescuento(ins);
      },
      verdescuento(ins) {
        this.insseleccionado = ins;
        this.$refs.ndescuentover.setdescuento(ins);
      },
      parsefecha(f) {
        if (!f) return '-';
        let fs = f.split(' ');
        let fs1 = fs[0].split('-');
        let fs2 = fs[1].split(':');
        return `${fs1[2]}/${fs1[1]}/${fs1[0]} ${fs2[0]}:${fs2[1]}`;
      },
      parseuser(u) {
        if (!u) return '-';
        if (!u.segundo_apellido) u.segundo_apellido = '';
        return `${u.nombres} ${u.primer_apellido} ${u.segundo_apellido}`;
      },
      onrespuesta() {
        this.getDatos();
      },
      resultadobusquedaest() {
        window.console.log(this.estudiantes);
      },
      onloadprogramas() {
        this.isloadingprograma = false;
      },
      async getDatos() {
        let idunidad = this.$store.state.CARGO.sede.unidad_negocio;
        let sedeid = this.$store.state.CARGO.sede.id;
        const vue = this;
        let url = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/pagos/descuentos?descuento_tipo_id=${this.tipo_descuento.id}&is_asc=false&estado=${this.estado}&page=${this.page}&size=${this.size}&unidad_negocio_id=${idunidad}&sede_id=${sedeid}`;
        if (this.filtroestudiante && typeof this.filtroestudiante == 'object')
          url += `&estudiante_id=${this.filtroestudiante.id}`;
        if (this.filtroprograma && typeof this.filtroprograma == 'object')
          url += `&programa_id=${this.filtroprograma.id}`;
        vue.loading = true;
        this.datos = [];
        xaxios
          .get(url)
          .then((res) => {
            window.console.log('DESCUENTOS LISTA: ', res.data.data);
            if (res.data == '' || !res.data.data) res.data = { data: { items: [], total: 0 } };
            let total = res.data.data.total;
            let aux = 0;
            let tam = 0;
            while (aux < total) {
              aux += vue.size;
              tam++;
            }
            vue.page_tam = tam;
            if (!res.data.data.items) res.data.data.items = [];
            res.data.data.items.forEach((x, i) => {
              x.nro = (vue.page - 1) * vue.size + i + 1;
              vue.datos.push(x);
            });
            vue.loading = false;
          })
          .catch((error) => {
            window.console.log(error);
            vue.loading = false;
          });
      },
      gettiposdescuentos() {
        const vue = this;
        const url = `${process.env.VUE_APP_API_REST}/api/v1/descuento-tipos`;
        xaxios
          .get(url)
          .then((res) => {
            let ff = [];
            vue.idrol = vue.$store.state.CARGO.id;
            res.data.data.forEach((x) => {
              x.text = x.nombre;
              ff.push(x);
            });
            vue.tipos_des = ff;
            let defa = ff.find((d) => d.id == 2);
            if (defa) vue.tipo_descuento = defa;
          })
          .catch((error) => {
            window.console.log(error);
          });
      },
      asyncfindestudiante() {
        this.$refs.abuscarpersona.asyncfindestudiante(false, this.filtroestudiante, this);
      },
    },
    mounted() {
      this.gettiposdescuentos();
      this.$refs.abuscarprogramas.listarprogramasgraphql(this);
      this.getDatos();
    },
  };
</script>

<style scoped>
.dl-page { min-height: 100vh; background: #f5f7fa; }

.dl-hero {
  background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%);
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.dl-hero__title { font-size: 1.15rem; font-weight: 700; color: #fff; letter-spacing: 0.02em; }
.dl-hero__sub   { font-size: 0.78rem; color: rgba(255,255,255,0.65); margin-top: 2px; }

.dl-body { padding: 20px 24px; }

.dl-filters-card { border-radius: 10px !important; border-color: #e3e8f0 !important; }
.dl-filters-card__title {
  font-size: 0.8rem !important; font-weight: 700 !important;
  color: #283593; letter-spacing: 0.02em; border-bottom: 1px solid #e8edf7;
}

.dl-table-card { border-radius: 10px !important; border-color: #e3e8f0 !important; overflow: hidden; }

.dl-table-toolbar { background: #fafbff; border-bottom: 1px solid #e8edf7; }

.dl-table >>> thead tr th {
  background: #e8edf7 !important;
  color: #1a237e !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid #c5cae9 !important;
  padding: 6px 12px !important;
}
.dl-table >>> tbody tr:hover { background: #f0f4ff !important; }
.dl-table >>> tbody tr td {
  font-size: 0.82rem;
  border-bottom: 1px solid #f0f0f0 !important;
  padding: 4px 12px !important;
}
</style>
